// extracted by mini-css-extract-plugin
export default {"socialIcon":"FooterComponent_socialIcon__O2+o-"};